import React, { useCallback, useState } from "react";
// import "@shopify/polaris/build/esm/styles.css";
import {
  BrowserRouter,
  useRoutes, // instead of "Switch"
} from "react-router-dom";
import "./Assets/Styles/globals.css";
import "./Assets/Styles/react-tagsinput.css";
import Login from "./Pages/Authentication/Login";
import NavigationLayout from "./Components/NavigationLayout";
import UsersAndPermissions from "./Pages/Settings/UsersAndPermissions";
import AddEditUser from "./Pages/Settings/AddEditUser";
import Universities from "./Pages/Universities/List";
import AddEditUniversity from "./Pages/Universities/AddEdit";
import Professors from "./Pages/Professors/List";
import AddEditProfessor from "./Pages/Professors/AddEdit";
import Schools from "./Pages/Schools/List";
import AddEditSchool from "./Pages/Schools/AddEdit";
import UniversitySubjects from "./Pages/UniversitySubjects/List";
import AddEditUniversitySubject from "./Pages/UniversitySubjects/AddEdit";
import Courses from "./Pages/Courses/List";
import AddEditCourse from "./Pages/Courses/AddEdit";
import Classes from "./Pages/Classes/List";
import AddClass from "./Pages/Classes/AddEdit";
import SchoolSubjects from "./Pages/SchoolSubjects/List";
import AddEditSchoolSubject from "./Pages/SchoolSubjects/AddEdit";
import Playlist from "./Pages/Playlists/List";
import AddEditPlaylist from "./Pages/Playlists/AddEdit";
import Users from "./Pages/Users/List";
import Playlists from "./Pages/Playlists/List";
import Files from "./Pages/Files/List";
import AddEditFile from "./Pages/Files/AddEdit";
import AddEditAnswer from "./Pages/QuestionsAndAnswers/AddEdit";
import QuestionsAndAnswers from "./Pages/QuestionsAndAnswers/List";
import Subjects from "./Pages/Subjects/List";
import AddEditSubject from "./Pages/Subjects/AddEdit";
import Sessions from "./Pages/Tutoring/List";
import AddEditSession from "./Pages/Tutoring/AddEdit";
import Requests from "./Pages/Requests/List";
import RequestDetails from "./Pages/Requests/RequestDetails";
import Lectures from "./Pages/Lectures/List";
import AddEditLecture from "./Pages/Lectures/AddEdit";
import Notes from "./Pages/Notes/List";
import AddEditNote from "./Pages/Notes/AddEdit";
import Orders from "./Pages/Orders/List";
import OrderDetails from "./Pages/Orders/OrderDetails";
import FilesNotes from "./Pages/FilesNotes/List";
import AddEditFileNote from "./Pages/FilesNotes/AddEdit";
import AddEditClassSubject from "./Pages/ClassSubjects/AddEdit";
import ClassesBySchool from "./Pages/ClassesBySchool/List";
import ClassSubjects from "./Pages/ClassesBySchool/Subjects";
import Banners from "./Pages/Banners/List";
import AddEditBanner from "./Pages/Banners/AddEdit";
import Notifications from "./Pages/Notifications/List";
import AddEditNotification from "./Pages/Notifications/AddEdit";
import UserDetails from "./Pages/Users/UserDetails";
import Emails from "./Pages/Settings/Emails";
import CourseSubscribers from "./Pages/Courses/Subscribers/List";
import AddCourseSubscriber from "./Pages/Courses/Subscribers/Add";
import AddNoteSubscriber from "./Pages/Notes/Subscribers/Add";
import NoteSubscribers from "./Pages/Notes/Subscribers/List";
import Dashboard from "./Pages/Dashboard";
import LectureSubscribers from "./Pages/Lectures/Subscribers/LectureSubscribers";
import AddLectureSubscriber from "./Pages/Lectures/Subscribers/AddLectureSubscriber";
import HlsConverter from "./Pages/HlsConverter/HlsConverter";
import AnalyticsOverview from "./Pages/Analytics/Overview";
import AnalyticsRevenue from "./Pages/Analytics/Revenue";
import AnalyticsCustomers from "./Pages/Analytics/Customers";
import AnalyticsProducts from "./Pages/Analytics/Products";
import AnalyticsSales from "./Pages/Analytics/Sales";

function App() {
  if (process.env.NODE_ENV === "production") {
    console.log = function () {};
  }

  return useRoutes([
    {
      path: "/",
      element: <Login />,
    },
     {
      path: "/admin/hls-converter",  
      element: (
        <NavigationLayout>
          <HlsConverter />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities",
      element: (
        <NavigationLayout>
          <Universities />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities/new",
      element: (
        <NavigationLayout>
          <AddEditUniversity type="add" />
        </NavigationLayout>
      ),
    },
    
    {
      path: "/admin/universities/:id",
      element: (
        <NavigationLayout>
          <AddEditUniversity type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/analytics",
      element: (
        <NavigationLayout>
          <AnalyticsOverview />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/analytics/revenue",
      element: (
        <NavigationLayout>
          <AnalyticsRevenue />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/analytics/customers",
      element: (
        <NavigationLayout>
          <AnalyticsCustomers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/analytics/products",
      element: (
        <NavigationLayout>
          <AnalyticsProducts />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/analytics/sales",
      element: (
        <NavigationLayout>
          <AnalyticsSales />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions",
      element: (
        <NavigationLayout>
          <Sessions />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions/new",
      element: (
        <NavigationLayout>
          <AddEditSession type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/sessions/:id",
      element: (
        <NavigationLayout>
          <AddEditSession type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/subjects",
      element: (
        <NavigationLayout>
          <Subjects />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/subjects/new",
      element: (
        <NavigationLayout>
          <AddEditSubject type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/subjects/:id",
      element: (
        <NavigationLayout>
          <AddEditSubject type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/universities/:id/subjects",
      element: (
        <NavigationLayout>
          <AddEditUniversitySubject />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id/subjects",
      element: (
        <NavigationLayout>
          <AddEditClassSubject />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities/:id/subjects/new",
      element: (
        <NavigationLayout>
          <AddEditUniversitySubject type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities/:id/subjects/:subjectId",
      element: (
        <NavigationLayout>
          <AddEditUniversitySubject type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities/:id/subjects/:subjectId/courses",
      element: (
        <NavigationLayout>
          <Courses />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities/:id/subjects/:subjectId/courses/new",
      element: (
        <NavigationLayout>
          <AddEditCourse type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities/:id/subjects/:subjectId/courses/:courseId",
      element: (
        <NavigationLayout>
          <AddEditCourse type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities/:id/subjects/:subjectId/courses/:courseId/playlists",
      element: (
        <NavigationLayout>
          <Playlist param="university" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities/:id/subjects/:subjectId/courses/:courseId/playlists/new",
      element: (
        <NavigationLayout>
          <AddEditPlaylist type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/universities/:id/subjects/:subjectId/courses/:courseId/playlists/:playlistId",
      element: (
        <NavigationLayout>
          <AddEditPlaylist type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/settings/users-and-permissions",
      element: (
        <NavigationLayout>
          <UsersAndPermissions />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/users-and-permissions/new",
      element: (
        <NavigationLayout>
          <AddEditUser type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/users-and-permissions/:id",
      element: (
        <NavigationLayout>
          <AddEditUser type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/requests",
      element: (
        <NavigationLayout>
          <Requests />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/requests/:id",
      element: (
        <NavigationLayout>
          <RequestDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/orders",
      element: (
        <NavigationLayout>
          <Orders />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/orders/:id",
      element: (
        <NavigationLayout>
          <OrderDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/professors",
      element: (
        <NavigationLayout>
          <Professors />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/professors/new",
      element: (
        <NavigationLayout>
          <AddEditProfessor type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/professors/:id",
      element: (
        <NavigationLayout>
          <AddEditProfessor type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/schools",
      element: (
        <NavigationLayout>
          <Schools />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/schools/new",
      element: (
        <NavigationLayout>
          <AddEditSchool type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/schools/:id",
      element: (
        <NavigationLayout>
          <AddEditSchool type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes",
      element: (
        <NavigationLayout>
          <Classes />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/new",
      element: (
        <NavigationLayout>
          <AddClass type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/classes/:id",
      element: (
        <NavigationLayout>
          <AddClass type="edit" />
        </NavigationLayout>
      ),
    },
    // {
    //   path: "/admin/schools/:id/classes/:classId/subjects",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditSchoolSubject />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/schools/:id/classes/:classId/subjects/new",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditSchoolSubject type="add" />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/schools/:id/classes/:classId/subjects/:subjectId",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditSchoolSubject type="edit" />
    //     </NavigationLayout>
    //   ),
    // },

    {
      path: "/admin/courses",
      element: (
        <NavigationLayout>
          <Courses />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/new",
      element: (
        <NavigationLayout>
          <AddEditCourse type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id",
      element: (
        <NavigationLayout>
          <AddEditCourse type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/playlists",
      element: (
        <NavigationLayout>
          <Playlists />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/playlists/new",
      element: (
        <NavigationLayout>
          <AddEditPlaylist type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/playlists/:playlistId",
      element: (
        <NavigationLayout>
          <AddEditPlaylist type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/courses/:id/files",
      element: (
        <NavigationLayout>
          <Files />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/files/new",
      element: (
        <NavigationLayout>
          <AddEditFile type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/files/:fileId",
      element: (
        <NavigationLayout>
          <AddEditFile type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/questions-and-answers",
      element: (
        <NavigationLayout>
          <QuestionsAndAnswers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/questions-and-answers/:questionId",
      element: (
        <NavigationLayout>
          <AddEditAnswer />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/lectures",
      element: (
        <NavigationLayout>
          <Lectures />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/lectures/new",
      element: (
        <NavigationLayout>
          <AddEditLecture type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/lectures/:lectureId",
      element: (
        <NavigationLayout>
          <AddEditLecture type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/lectures/:lectureId/playlists",
      element: (
        <NavigationLayout>
          <Playlists />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/lectures/:lectureId/playlists/new",
      element: (
        <NavigationLayout>
          <AddEditPlaylist type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/lectures/:lectureId/playlists/:playlistId",
      element: (
        <NavigationLayout>
          <AddEditPlaylist type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/courses/:id/lectures/:lectureId/files",
      element: (
        <NavigationLayout>
          <Files />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/lectures/:lectureId/files/new",
      element: (
        <NavigationLayout>
          <AddEditFile type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/lectures/:lectureId/files/:fileId",
      element: (
        <NavigationLayout>
          <AddEditFile type="edit" />
        </NavigationLayout>
      ),
    },
    {
  path: "/admin/courses/:id/lectures/:lectureId/subscribers",
  element: (
    <NavigationLayout>
      <LectureSubscribers />
    </NavigationLayout>
  ),
},
{
  path: "/admin/courses/:id/lectures/:lectureId/subscribers/new",
  element: (
    <NavigationLayout>
      <AddLectureSubscriber />
    </NavigationLayout>
  ),
},
    {
      path: "/admin/courses/:id/notes",
      element: (
        <NavigationLayout>
          <Notes />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/notes/new",
      element: (
        <NavigationLayout>
          <AddEditNote type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/notes/:noteId",
      element: (
        <NavigationLayout>
          <AddEditNote type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/notes/:noteId/files",
      element: (
        <NavigationLayout>
          <FilesNotes />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/notes/:noteId/files/new",
      element: (
        <NavigationLayout>
          <AddEditFileNote type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/notes/:noteId/files/:fileId",
      element: (
        <NavigationLayout>
          <AddEditFileNote type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/subscribers",
      element: (
        <NavigationLayout>
          <CourseSubscribers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/subscribers/new",
      element: (
        <NavigationLayout>
          <AddCourseSubscriber />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/notes/:noteId/subscribers",
      element: (
        <NavigationLayout>
          <NoteSubscribers />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/courses/:id/notes/:noteId/subscribers/new",
      element: (
        <NavigationLayout>
          <AddNoteSubscriber />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/users",
      element: (
        <NavigationLayout>
          <Users />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/users/:id",
      element: (
        <NavigationLayout>
          <UserDetails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/schools/:id/classes",
      element: (
        <NavigationLayout>
          <ClassesBySchool type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/schools/:id/classes/:classId/subjects",
      element: (
        <NavigationLayout>
          <ClassSubjects />
        </NavigationLayout>
      ),
    },

    // {
    //   path: "/admin/notes",
    //   element: (
    //     <NavigationLayout>
    //       <Notes />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/notes/new",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditNote type="add" />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/notes/:id",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditNote type="edit" />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/notes/:id/files",
    //   element: (
    //     <NavigationLayout>
    //       <FilesNotes />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/notes/:id/files",
    //   element: (
    //     <NavigationLayout>
    //       <FilesNotes />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/notes/:id/files/new",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditFileNote type="add" />
    //     </NavigationLayout>
    //   ),
    // },
    // {
    //   path: "/admin/notes/:id/files/:fileId",
    //   element: (
    //     <NavigationLayout>
    //       <AddEditFileNote type="edit" />
    //     </NavigationLayout>
    //   ),
    // },

    {
      path: "/admin/banners",
      element: (
        <NavigationLayout>
          <Banners />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/banners/new",
      element: (
        <NavigationLayout>
          <AddEditBanner type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/banners/:id",
      element: (
        <NavigationLayout>
          <AddEditBanner type="edit" />
        </NavigationLayout>
      ),
    },

    {
      path: "/admin/notifications",
      element: (
        <NavigationLayout>
          <Notifications />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/notifications/new",
      element: (
        <NavigationLayout>
          <AddEditNotification type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/notifications/:id",
      element: (
        <NavigationLayout>
          <AddEditNotification type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/emails",
      element: (
        <NavigationLayout>
          <Emails />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/dashboard",
      element: (
        <NavigationLayout>
          <Dashboard />
        </NavigationLayout>
      ),
    },
  ]);
}
export default App;
